export enum ESituation {
	assuranceMaladie = "AS",
	accidentTravail = "AT",
	maternite = "MA",
	preventionMaladie = "PM",
	soinsMedicauxGratuits = "SM",
}
